// src/utils/pushNotificationService.js

import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

let userRegHandle = null;
let userErrHandle = null;

/**
 * Ensure we wire up your real callback exactly once
 * @param {(token) => void} onRegistration
 * @param {(error) => void} onError
 */
export async function ensureRegistrationListeners(onRegistration, onError) {
    if (!Capacitor.isPluginAvailable('PushNotifications') || userRegHandle) {
        return;
    }
    userRegHandle = await PushNotifications.addListener('registration', onRegistration);
    userErrHandle = await PushNotifications.addListener('registrationError', onError);
}
